import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { VueHammer } from "vue2-hammer";
import * as VueGoogleMaps from "vue2-google-maps";
import AudioPlayer from "@liripeng/vue-audio-player";

const language = JSON.parse(localStorage.getItem("mobileLang"))
  ? JSON.parse(localStorage.getItem("mobileLang")).code
  : "en";

VueHammer.config.swipe = {
  direction: 6,
};
Vue.use(VueHammer);

Vue.use(AudioPlayer);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCOisWmQPxQ-U5ydqquLR4hUgTM0O03u7Y", //production key

    // key: "AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg",
    libraries: "places", // This is required if you use the Autocomplete plugin
    language: language,
    region: "GR",
    version: "weekly",
  },
});

import i18n from "./i18n";
import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader

Vue.use(vuetify, {
  iconfont: "md",
});

var filter = function (text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter("truncate", filter);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
